<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{title}}</h4>
    <button type="button" class="close" (click)="closeCodemirrorDialog()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" id="modal-body">
    <ngx-codemirror #codemirror name="testdata-value" class="javascript-editor" [(ngModel)]="testdataValue" [ngModelOptions]="{ standalone: true }" [options]="codeMirrorOptions"></ngx-codemirror>
</div>
<div class="modal-footer confirm-footer">
    <button class="btn relay-btn relay-createbtn update" type="button" (click)="saveCodemirrorValue()">Update</button>

    <!-- buttons for Cancel Confirmation Modal -->
    <button class="btn relay-btn cancel" type="button" (click)="closeCodemirrorDialog()">Cancel</button>
</div>